// User-Agent ve istek başlıklarından okunabilir ortam bilgisi çıkarır.
//
// Kesin cihaz tespiti YOKTUR: User-Agent istemcinin beyanıdır, taklit
// edilebilir ve modern tarayıcılar bilinçli olarak sadeleştirir. Buradaki
// amaç adli kesinlik değil, "kim nereden baktı" sorusuna pratik bir yanıt.
//
// Özel bir durum: posta sağlayıcılarının görsel vekilleri (Gmail, Yahoo)
// kendi sabit User-Agent'larını gönderir — o satırlarda görünen "Windows"
// alıcının işletim sistemi DEĞİL, Google'ın sunucusudur. Bu yüzden vekil
// tespiti ilk sırada yapılır ve ayrıca işaretlenir.

export type Ortam = {
  tarayici: string;
  surum: string;
  isletim: string;
  cihaz: "Masaüstü" | "Mobil" | "Tablet" | "Bot" | "Posta vekili" | "Bilinmiyor";
  bot: boolean;
  vekil: boolean;   // posta sağlayıcısının görsel vekili
  /** Tabloda GÖRÜNEN satır: tarayıcı + sürüm · cihaz sınıfı (bot ise "(bot)").
   *  Alınmasına karar verilen dört alan bunlar (2026-08-18). İşletim sistemi
   *  bilinçli olarak burada DEĞİL — ölçüldü, taşıdığı bilgi zayıf: Windows
   *  trafiğinin %90,8'i "NT 10.0" diyor (10 ile 11 ayırt edilemiyor) ve macOS'un
   *  %34'ü donmuş "10_15_7". Satırı uzatıp tarama işini yavaşlatıyordu. */
  ozet: string;
  /** TOOLTIP satırı: işletim sistemi dâhil tam hâli. Bilgi kaybolmasın diye —
   *  bir tık uzakta duruyor, satırda yer kaplamıyor. */
  detay: string;
};

const BOS: Ortam = {
  tarayici: "—", surum: "", isletim: "—", cihaz: "Bilinmiyor",
  bot: false, vekil: false, ozet: "—", detay: "User-Agent başlığı yok",
};

function surumBul(ua: string, kalip: RegExp): string {
  const m = ua.match(kalip);
  return m?.[1] ? m[1].split(".").slice(0, 2).join(".") : "";
}

export function ortamCoz(ua?: string): Ortam {
  if (!ua) return BOS;

  // 1) Posta vekilleri — alıcının cihazı hakkında bilgi VERMEZ.
  if (/GoogleImageProxy/i.test(ua)) {
    return { ...BOS, tarayici: "Gmail görsel vekili", cihaz: "Posta vekili", vekil: true, ozet: "Gmail görsel vekili", detay: "Gmail görsel vekili — alıcının cihazı hakkında bilgi VERMEZ" };
  }
  if (/YahooMailProxy/i.test(ua)) {
    return { ...BOS, tarayici: "Yahoo Mail vekili", cihaz: "Posta vekili", vekil: true, ozet: "Yahoo Mail vekili", detay: "Yahoo Mail vekili — alıcının cihazı hakkında bilgi VERMEZ" };
  }

  // 2) Botlar / tarayıcılar.
  if (/bot|crawler|spider|slurp|bingpreview|facebookexternalhit|whatsapp|telegram/i.test(ua)) {
    const ad = ua.match(/([A-Za-z]+(?:bot|crawler|spider))/i)?.[1] ?? "Bot";
    // Bot durumu METİNLE taşınır ("(bot)"), yalnız renkle değil — hem baskı
    // hem renk körlüğü (design-system §2).
    return { ...BOS, tarayici: ad, cihaz: "Bot", bot: true,
      ozet: `${ad} (bot)`, detay: `${ad} — otomatik istemci (bot)` };
  }

  // 3) Tarayıcı — sıra önemli: Edge ve Opera kendilerini Chrome diye de tanıtır.
  let tarayici = "Bilinmeyen", surum = "";
  if (/Edg\//.test(ua))            { tarayici = "Edge";    surum = surumBul(ua, /Edg\/([\d.]+)/); }
  else if (/OPR\/|Opera/.test(ua)) { tarayici = "Opera";   surum = surumBul(ua, /(?:OPR|Opera)\/([\d.]+)/); }
  else if (/SamsungBrowser/.test(ua)) { tarayici = "Samsung Internet"; surum = surumBul(ua, /SamsungBrowser\/([\d.]+)/); }
  else if (/Firefox\//.test(ua))   { tarayici = "Firefox"; surum = surumBul(ua, /Firefox\/([\d.]+)/); }
  else if (/Chrome\//.test(ua))    { tarayici = "Chrome";  surum = surumBul(ua, /Chrome\/([\d.]+)/); }
  else if (/Safari\//.test(ua))    { tarayici = "Safari";  surum = surumBul(ua, /Version\/([\d.]+)/); }
  else if (/curl\//i.test(ua))     { tarayici = "curl";    surum = surumBul(ua, /curl\/([\d.]+)/); }

  // 4) İşletim sistemi.
  let isletim = "Bilinmiyor";
  if (/Windows NT 10/.test(ua))      isletim = "Windows 10/11";
  else if (/Windows NT 6\.3/.test(ua)) isletim = "Windows 8.1";
  else if (/Windows/.test(ua))       isletim = "Windows";
  else if (/Android/.test(ua))       isletim = `Android ${surumBul(ua, /Android ([\d.]+)/)}`.trim();
  else if (/iPhone|iPad|iPod/.test(ua)) isletim = `iOS ${surumBul(ua, /OS ([\d_]+)/).replace(/_/g, ".")}`.trim();
  else if (/Mac OS X/.test(ua))      isletim = `macOS ${surumBul(ua, /Mac OS X ([\d_]+)/).replace(/_/g, ".")}`.trim();
  else if (/CrOS/.test(ua))          isletim = "ChromeOS";
  else if (/Linux/.test(ua))         isletim = "Linux";

  // 5) Cihaz sınıfı.
  let cihaz: Ortam["cihaz"] = "Masaüstü";
  if (/iPad|Tablet/i.test(ua)) cihaz = "Tablet";
  else if (/Mobi|Android.*Mobile|iPhone|iPod/i.test(ua)) cihaz = "Mobil";

  const ozet = [
    tarayici + (surum ? ` ${surum}` : ""),
    cihaz,
  ].filter(Boolean).join(" · ");

  // detay = ozet + isletim sistemi. Tooltip'te durur; satirda yer kaplamaz.
  const detay = [
    tarayici + (surum ? ` ${surum}` : ""),
    isletim !== "Bilinmiyor" ? isletim : "",
    cihaz,
  ].filter(Boolean).join(" · ");

  return { tarayici, surum, isletim, cihaz, bot: false, vekil: false, ozet, detay };
}

// dilCoz — Accept-Language başlığının ilk tercihini okunur hâle getirir.
export function dilCoz(lang?: string): string {
  if (!lang) return "—";
  const ilk = lang.split(",")[0]?.trim();
  if (!ilk) return "—";
  const adlar: Record<string, string> = {
    tr: "Türkçe", en: "İngilizce", de: "Almanca", fr: "Fransızca",
    es: "İspanyolca", it: "İtalyanca", ru: "Rusça", ar: "Arapça",
    nl: "Felemenkçe", pt: "Portekizce", zh: "Çince", ja: "Japonca",
  };
  const kok = ilk.split("-")[0].toLowerCase();
  return adlar[kok] ? `${adlar[kok]} (${ilk})` : ilk;
}

// kaynakCoz — "nereden geldi" özeti.
//
// `mailden` bayrağı şart: maildeki bağlantıdan gelen ilk sayfada Referer
// GELMEZ — Gmail bağlantılara `noreferrer` koyar, ayrıca sitenin kendi
// Referrer-Policy'si (strict-origin-when-cross-origin) de kaynağı kısar.
// Bu yüzden boş Referer "doğrudan geldi" DEMEK DEĞİLDİR; ziyaretçinin
// mailden geldiğini token eşleşmesinden zaten biliyoruz ve doğrusunu
// yazmak gerekir (ölçüldü: mailden gelen ziyaret "Doğrudan" görünüyordu).
export function kaynakCoz(ref?: string, mailden = false): string {
  if (!ref) return mailden ? "E-posta kampanyası" : "Doğrudan / bilinmiyor";
  try {
    const u = new URL(ref);
    const h = u.hostname.replace(/^www\./, "");
    if (/google\./.test(h)) return "Google araması";
    if (/bing\./.test(h)) return "Bing araması";
    if (/yandex\./.test(h)) return "Yandex araması";
    if (/duckduckgo\./.test(h)) return "DuckDuckGo";
    if (/linkedin\./.test(h)) return "LinkedIn";
    if (/facebook\.|instagram\./.test(h)) return "Meta (Facebook/Instagram)";
    if (/t\.co|twitter\.|x\.com/.test(h)) return "X (Twitter)";
    if (/medregai\.com$/.test(h)) return "Site içi";
    return h;
  } catch {
    return ref.slice(0, 60);
  }
}
